export const handleNin9rsSocketResponse = (socketResponse, competitionsId, env, setData) => {
    if (socketResponse &&
        competitionsId.includes(socketResponse.competicion) &&
        socketResponse.env === env) {
        setData(prevData => {
            if (null === prevData) {
                return null;
            }
            const newData = [...prevData];
            for (let i = 0; i < newData.length; i++) {
                const groupCompetitionIndex = newData[i].competitions.findIndex(comp => comp.competition.id === socketResponse.competicion);
                if (groupCompetitionIndex !== -1) {
                    newData[i] = Object.assign(Object.assign({}, newData[i]), { competitions: [
                            ...newData[i].competitions.slice(0, groupCompetitionIndex),
                            socketResponse.data,
                            ...newData[i].competitions.slice(groupCompetitionIndex + 1)
                        ] });
                    break;
                }
            }
            return newData;
        });
    }
};
